import { importProvidersFrom, makeStateKey, TransferState } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

export class TransferStateTranslateLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly transferState: TransferState
  ) {}

  getTranslation(language: string): Observable<Record<string, unknown>> {
    const stateKey = makeStateKey<Record<string, unknown>>(`i18n-${language}`);
    const translation = this.transferState.get(stateKey, null);

    if (translation) {
      this.transferState.remove(stateKey);
      return of(translation);
    }

    return this.http.get<Record<string, unknown>>(`assets/i18n/${language}.json`);
  }
}

export function provideTranslate() {
  return importProvidersFrom(
    TranslateModule.forRoot({
      defaultLanguage: 'de',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient, transferState: TransferState) =>
          new TransferStateTranslateLoader(http, transferState),
        deps: [HttpClient, TransferState]
      }
    })
  );
}
